// Famílies de gràfic ApexCharts segons la FORMA de dades que consumeixen. El canvi de
// tipus en viu (el <select> de ChartWidget) només pot moure's DINS d'una família, perquè
// dins d'una família el node de dades té la mateixa forma (series/categories vs series/labels)
// i no cal refetch ni reshape. Creuar famílies (p.ex. donut→bar) és un canvi PERSISTIT que
// passa per applyType (reconstrueix params + invalida el node).
//
//   cartesian → node { series:[{name,data}], categories }
//   circular  → node { series:number[], labels }
//   (table no és un gràfic ApexCharts: es renderitza com a taula, mai dins el <select>.)

export const CHART_FAMILIES = {
  cartesian: ['bar', 'line', 'area'],
  circular: ['donut', 'pie']
};

/** Família d'un chart.type ('cartesian' | 'circular' | null). */
export function familyOf(chartType) {
  for (const fam of Object.keys(CHART_FAMILIES)) {
    if (CHART_FAMILIES[fam].includes(chartType)) return fam;
  }
  return null;
}

/** Membres de la família d'un chart.type (array buit si no en té). */
export function familyMembers(chartType) {
  const fam = familyOf(chartType);
  return fam ? CHART_FAMILIES[fam] : [];
}
